export default {
      id: "icon-flag-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-flag",
      toString: function () {
        return this.url;
      }
    }